import { NgModule } from '@angular/core';
import { HrefHttpPipeModule } from '@kiss/pipes/href-http/href-http.module';
import { SafeHtmlPipeModule } from './safe-html/safe-html.module';

@NgModule({
  imports: [HrefHttpPipeModule, SafeHtmlPipeModule],
  exports: [HrefHttpPipeModule, SafeHtmlPipeModule],
})
export class KissPipesModule {}
